class ManageReportsController {
    constructor($window, $uibModal, ModalService, toastr, ngProgressFactory, UserDetailsApi, ReportServiceApi) {
        this.$onInit = () => {
            this.userDetails = null;
            this.rowCount = 0;
            this.state = {
                centered: true,
                linkFromName: true,
                selectedSim: -1,
                selectedReport: null,
                activeOnly: false
            };
            this.data = {
                reports: [],
                filterOptions: {
                    allReports: [],
                    activeOnly: []
                }
            };
            this.traceProgress = this.ngProgressFactory.createInstance();
            let columnDefs = [
                { headerName: 'Id', field: 'Id', minWidth: 60, width: 60, maxWidth: 60, suppressMovable: true, suppressMenu: true, resizable: false },
                { headerName: 'Report Name', field: 'Name', width: 135, minWidth: 135, cellRenderer: this.nameCellRenderer },
                { headerName: 'Description', field: 'Description', width: 180, minWidth: 130 },
                { headerName: 'Order', field: 'ReportOrder', width: 90, minWidth: 90, maxWidth: 90 },
                { headerName: 'Icon Name', field: 'Icon', width: 230, minWidth: 125 },
                { headerName: 'Icon Image', field: 'Icon', width: 100, minWidth: 100, cellRenderer: this.iconRenderer, sortable: false, suppressMenu: true, resizable: true, suppressMovable: true },
                { headerName: 'Active', field: 'IsDeleted', width: 100, minWidth: 90, cellRenderer: this.statusRenderer, sortable: true, suppressMenu: true, resizable: true, suppressMovable: true },
                { headerName: 'External', field: 'IsExternal', width: 100, minWidth: 90, cellRenderer: this.booleanRenderer, sortable: true, suppressMenu: true, resizable: true, suppressMovable: true },
                { headerName: 'Actions', width: 140, maxWidth: 140, minWidth: 140, cellRenderer: this.actionsCellRenderer, sortable: false, suppressMenu: true, resizable: false, suppressMovable: true }
            ];
            this.gridOptions = {
                defaultColDef: {
                    resizable: true,
                    sortable: true,
                    filter: false
                },
                columnDefs: columnDefs,
                onModelUpdated: this.onModelUpdated,
                rowSelection: 'single',
                angularCompileRows: true,
                suppressMovableColumns: true, // Added because of ag-grid bug see https://github.com/ceolter/ag-grid/issues/965#issuecomment-225857509
            };
            this.traceProgress.start();
            this.UserDetailApi.get().then((response) => {
                this.userDetails = response.data;
            });
            this.getReports();
        };
        this.actionsCellRenderer = (row) => {
            let editReport = this.createAction('vm.editReport(data)', 'Edit Report', 'glyphicon glyphicon-pencil', '');
            let editReportAccess = this.createAction('vm.editReportAccess(data)', 'Edit Report Access', 'fa fa-shield', '');
            let assignToSims = this.createAction('vm.assignReportSimulators(data)', 'Assign To Simulators', 'glyphicon glyphicon-transfer', '');
            let deleteReport = this.createAction('vm.deactivateReport(data)', 'Deactivate Report', 'glyphicon glyphicon-trash', '<i class="fa fa-spinner fa-spin" ng-if="data.deleting"></i>');
            let actions = editReport + editReportAccess;
            if (row.data.IsExternal) {
                actions += assignToSims;
            }
            if (!row.data.IsDeleted) {
                actions += deleteReport;
            }
            return '<div class="ag-grid-actions-container">' + actions + '</div>';
            ;
        };
        this.iconRenderer = (row) => {
            let icon = [
                '<div class="text-center"><i class="', row.data.Icon, 'space-right"></i></div>'
            ].join(' ');
            if (this.state.centered !== true) {
                icon = [
                    '<div class=""><i class="', row.data.Icon, 'space-right"></i></div>'
                ].join(' ');
            }
            return icon;
        };
        this.statusRenderer = (row) => {
            let active = 'Yes';
            if (row.data.IsDeleted) {
                active = 'No';
            }
            let status = ['<div class="text-center">' + active + '</div>'].join(' ');
            if (this.state.centered !== true) {
                status = ['<div class="">' + active + '</div>'].join(' ');
            }
            return status;
        };
        this.booleanRenderer = (params) => {
            let active = params.value ? 'Yes' : 'No';
            let status = ['<div class="text-center">' + active + '</div>'].join(' ');
            if (this.state.centered !== true) {
                status = ['<div class="">' + active + '</div>'].join(' ');
            }
            return status;
        };
        this.nameCellRenderer = (row) => {
            let tooltip = 'Edit Report';
            let action = 'vm.editReport(data)';
            return this.createLink(row.data.Name, tooltip, action);
        };
        this.createAction = (method, popoverText, icon, spinner) => {
            let action = [
                '<button class="btn btn-xs btn-info"',
                'ng-click="', method, '"',
                'uib-popover="', popoverText, '"',
                'popover-animation',
                'popover-trigger="\'mouseenter\'"',
                'popover-placement="left"',
                'popover-append-to-body="true">',
                '<i class="', icon, '">',
                '</i>',
                spinner,
                '</button>'
            ].join(' ');
            return action;
        };
        this.defaultSort = () => {
            this.gridOptions.columnApi.applyColumnState({
                state: [{ colId: 'Name', sort: 'asc' }]
            });
        };
        this.createLink = (data, tooltip, action) => {
            let link = ['<span',
                'ng-if="!vm.state.linkFromName">',
                data,
                '</span><a ng-href=""',
                'class="pointer"',
                'uib-popover="',
                tooltip,
                '"',
                'popover-animation',
                'popover-trigger="\'mouseenter\'"',
                'popover-placement="right"',
                'popover-append-to-body="true"',
                'ng-if="vm.state.linkFromName"',
                'ng-click="',
                action,
                '">',
                data,
                '</a>'
            ].join(' ');
            return link;
        };
        this.resetSelection = () => {
            this.gridOptions.api.forEachNode((node) => {
                if (node.data.Id === this.state.selectedSim) {
                    node.setSelected(true);
                }
                else {
                    node.setSelected(false);
                }
            });
        };
        this.addReport = () => {
            // Create a new report
            // Create empty report to pass to edit report
            let emptyReport = { Id: -1, IsDeleted: false };
            // use editReport to get the new report
            // details and save
            this.editReport(emptyReport);
        };
        this.editReport = (report) => {
            // Set row Selected
            this.state.selectedReport = report;
            // edit or create a Reports using a modal dailog
            // If report.Id is -1 a new report will be created
            // otherwise the details of the existing report may be edited
            // Open in Modal dialog
            // All updates to the database are handled by AddEditReport.controller.js
            let reportEditModal = this.uibModal.open({
                animation: true,
                component: 'addEditReportModal',
                size: 'md',
                backdrop: 'static',
                resolve: {
                    report: () => {
                        return report;
                    }
                }
            });
            reportEditModal.result.then((action) => {
                if (action === 'Saved' || action === 'UpdatedStatus') {
                    let msg = [
                        'Report ',
                        action,
                        '!'
                    ].join('');
                    this.toastr.info(msg);
                }
                // Check if the Modal was closed because of an update - if so reload the grid.
                if (action === 'Saved') {
                    this.traceProgress.start();
                    // tslint:disable-next-line:variable-name
                    this.ReportServiceApi.getReports().then((reports_response) => {
                        this.data.reports = reports_response.data;
                        this.gridOptions.api.setRowData(this.data.reports);
                        this.traceProgress.complete();
                    });
                }
                else if (action === 'UpdatedStatus') {
                    this.window.location.reload();
                }
            });
        };
        this.deactivateReport = (report) => {
            // console.log(report);
            // Set row Selected
            this.state.selectedReport = report;
            // Deactivate Report
            // First ask the user if they are sure they want to deactivate
            let modalOptions = {
                backdrop: 'static',
                actionButtonText: 'OK',
                closeButtonText: 'Cancel',
                headerText: 'Deactivate Report',
                bodyText: 'Are you sure you want to deactivate ' + report.Name + ' ?'
            };
            this.ModalService.showModal({}, modalOptions).then(() => {
                // Wait for user to decide if the simulator should be deactivated
                this.ReportServiceApi.deactivateReport(report.Id).then((response) => {
                    let succeeded = ((response.status === 200) && (response.data === true));
                    if (succeeded) {
                        this.getReports();
                        this.gridOptions.api.setRowData(this.data.reports);
                    }
                    else {
                        let reason = 'Failed to deactivate report.';
                        this.toastr.error(reason, 'Error');
                    }
                });
            });
        };
        this.editReportAccess = (report) => {
            // Set row Selected
            this.state.selectedReport = report;
            // Open in Modal dialog
            let reportAccessModal = this.uibModal.open({
                animation: true,
                component: 'manageReportAccessModal',
                size: 'sm',
                backdrop: 'static',
                resolve: {
                    report: () => {
                        return report;
                    }
                }
            });
            reportAccessModal.result.then((action) => {
                // console.log(action);
                // Check if the Modal was closed because of an update - if so reload the page - to get new menu.
                if (action === 'update') {
                    this.window.location.reload();
                }
            });
        };
        this.assignReportSimulators = (report) => {
            // Set row Selected
            this.state.selectedReport = report;
            // Open in Modal dialog
            let reportAccessModal = this.uibModal.open({
                animation: true,
                component: 'assignReportSimulatorsModal',
                size: 'md',
                backdrop: 'static',
                resolve: {
                    report: () => {
                        return report;
                    }
                }
            });
        };
        this.getReports = () => {
            // tslint:disable-next-line:variable-name
            this.ReportServiceApi.getReports().then((reports_response) => {
                let OnlyActiveReports = _.filter(reports_response.data, report => {
                    return report.IsDeleted === false;
                });
                this.data = {
                    reports: reports_response.data,
                    filterOptions: {
                        allReports: reports_response.data,
                        activeOnly: OnlyActiveReports
                    }
                };
                this.filterRows();
                this.gridOptions.api.setRowData(this.data.reports);
                this.defaultSort();
                this.gridOptions.api.sizeColumnsToFit();
                this.traceProgress.complete();
            });
        };
        this.onModelUpdated = () => {
            let model = this.gridOptions.api.getModel();
            let processedRows = model.getRowCount();
            this.rowCount = processedRows;
        };
        this.toggleActiveOnly = () => {
            this.state.activeOnly = !this.state.activeOnly;
            this.filterRows();
            this.gridOptions.api.setRowData(this.data.reports);
        };
        this.filterRows = () => {
            if (this.state.activeOnly) {
                this.data.reports = this.data.filterOptions.activeOnly;
            }
            else {
                this.data.reports = this.data.filterOptions.allReports;
            }
        };
        this.window = $window;
        this.uibModal = $uibModal;
        this.ModalService = ModalService;
        this.toastr = toastr;
        this.UserDetailApi = UserDetailsApi;
        this.ngProgressFactory = ngProgressFactory;
        this.ReportServiceApi = ReportServiceApi;
    }
}
angular.module('app').component('manageReports', {
    bindings: {},
    templateUrl: 'Scripts/App/partials/Reports/manage-reports.tpl.html',
    controllerAs: 'vm',
    controller: ManageReportsController
});
